import { useTranslation } from 'react-i18next';
import { archiveSubscriptionPrice } from './utils/archiveSubscriptionPrice';
import { useAuthContext } from '../../../contexts/AuthContext';
import { useErrorMessage } from '../../../utils/errorMessage';
import {
  createDateColumns,
  createArchiveActionsColumn
} from '../utils/columnsUtils';

export const useColumns = ({
  setPurpose,
  setSubscriptionPriceToEdit,
  setVisible
}) => {
  const { t } = useTranslation();
  const { dispatchAPI } = useAuthContext();
  const { message } = useErrorMessage();

  return [
    ...createDateColumns(t, 'subscription-prices.form'),
    {
      title: t('subscription-prices.form.price'),
      key: 'price',
      dataIndex: 'price',
      render: (price) => (price ? `${price} €` : ''),
      sorter: true
    },
    createArchiveActionsColumn({
      setPurpose,
      setRecordToEdit: setSubscriptionPriceToEdit,
      setVisible,
      onArchive: archiveSubscriptionPrice,
      t,
      dispatchAPI,
      message
    })
  ];
};
